import { MouseEventHandler, useCallback } from 'react';
import { isAcademyLink, useAcademyOnClick } from './useAcademyLink';

// The click handler a resource link needs, or undefined for a plain link. A
// lookup rather than a per-link hook, so callers can use it inside a map.
export function useResourceOnClick() {
  const academyOnClick = useAcademyOnClick();

  return useCallback(
    (link: string): MouseEventHandler<HTMLAnchorElement> | undefined =>
      isAcademyLink(link) ? academyOnClick : undefined,
    [academyOnClick],
  );
}
